import React from 'react';
import StravaLogo from '@strava/ui/StravaLogo';
import Button from '@strava/ui/Button';
import { EXPERIMENT_COHORTS } from '@strava/constants/src/appConstants';
import { useFrontDoorsPageContainerContext } from '../../../../state/FrontDoorsPageContainerContext';
import styles from './DesktopNav.module.scss';
import IconButton from '../../../IconButton';

const DesktopNav = () => {
  const { t, track, state } = useFrontDoorsPageContainerContext();
  const { cohort, menuConfig, header = {} } = state;
  const { showLoginOptionOnly } = menuConfig;
  const { analyticsProperties } = header;

  const handleLoginBtnClick = () => {
    track({
      element: 'login_header',
      action: 'click',
      ...(analyticsProperties && { properties: analyticsProperties })
    });
    window.location.href = '/login';
  };

  const handleSignupBtnClick = () => {
    track({
      element: 'start_signup',
      action: 'click',
      properties: {
        signup_copy: 'join_header',
        ...(analyticsProperties || {})
      }
    });
    window.location.href = '/register';
  };

  const handleLogoClick = () => {
    track({
      element: 'strava_logo',
      action: 'click',
      ...(analyticsProperties && { properties: analyticsProperties })
    });
    window.location.href = '/';
  };

  // TODO - cleanup after experiment https://strava.atlassian.net/browse/ACQN-301
  const signupBtnCopy = () => {
    // join_us -> 'Join For Free'
    const key = cohort === EXPERIMENT_COHORTS.variantA ? 'join_now' : 'join_us';
    return t(`header.${key}`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <IconButton onClick={handleLogoClick} ariaLabel="Strava">
          <StravaLogo width={95} height={20} alt="" />
        </IconButton>
      </div>
      <div className={styles.item}>
        <Button
          className={styles.loginBtn}
          type="button"
          onClick={handleLoginBtnClick}
          data-cy="login_btn"
          variant={showLoginOptionOnly ? 'primary' : 'default'}
        >
          {t('header.log_in')}
        </Button>
        {!showLoginOptionOnly && (
          <Button
            className={styles.signupBtn}
            type="button"
            onClick={handleSignupBtnClick}
            data-cy="signup_btn"
            variant="primary"
          >
            {signupBtnCopy()}
          </Button>
        )}
      </div>
    </div>
  );
};

export default DesktopNav;
